import type { Lang } from "./types";
import en from "./locales/en";
import es from "./locales/es";
import fr from "./locales/fr";
import pt from "./locales/pt";
import it from "./locales/it";
import de from "./locales/de";
import ar from "./locales/ar";

const supported: Lang[] = ["en", "es", "fr", "pt", "it", "de", "ar"];

export function detectLang(): Lang {
  if (typeof navigator === "undefined") return "en";
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language]) || [];
  for (const l of langs) {
    const code = l.toLowerCase().split("-")[0] as Lang;
    if (supported.includes(code)) return code;
  }
  return "en";
}

export const bundles = { en, es, fr, pt, it, de, ar } as const;

export function useLocale() {
  return bundles[detectLang()];
}
